import React, { useEffect, useState } from "react";
import Sidebar from "../../TutorDashboard/Components/sidebarAdmin";
import Header from "../../TutorDashboard/Components/headerAdmin";
import ResourcesForm from "./ResourcesForm";
import { Box, Container, Typography, Tabs, Tab } from "@mui/material";

import axios from "axios";
import ResourcesList from "./ResourcesList";

const Resources = () => {
  const [itsClicked, setItsClicked] = useState("resources");
  const [allResources, setAllResources] = useState([]);
  const [musicResources, setMusicResources] = useState([]);
  const [tabIndex, setTabIndex] = useState(0); // Tab index state

  const getAllResources = async () => {
    try {
      const response = await axios.get(
        "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/resources/get-all-resources",
        { timeout: 5000 }
      );
      if (response?.data?.resources) {
        setAllResources(response.data.resources);
        console.log(response.data.resources);
      }
    } catch (error) {
      console.error("Error saving document:", error);
      setAllResources([]);
    }
  };
  const getMusicResources = async () => {
    try {
      const response = await axios.get(
        "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/resources/get-all-resources",
        { timeout: 5000 }
      );
      if (response?.data?.resources) {
        setMusicResources(response.data.resources);
        console.log(response.data.resources);
      }
    } catch (error) {
      console.error("Error saving document:", error);
      setMusicResources([]);
    }
  };
  useEffect(() => {
    if (tabIndex === 0) getAllResources();
    else getMusicResources()
  }, [tabIndex]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <>
      <Sidebar itsClicked={itsClicked} />
      <Header />
      <div>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "4rem",
          }}
          component="main"
          sx={{
            flexGrow: 1,
            py: 8,
            backgroundColor: "rgb(248 248 248)",
          }}
        >
          <Container
            maxWidth="lg"
            style={{ maxWidth: "900px", paddingBottom: "15rem" }}
          >
            <Typography sx={{ mb: 1 }} variant="h4">
              Resources
            </Typography>

            {/* Tabs for Academic and Music */}
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              aria-label="Resource tabs"
              sx={{ mb: 2 }}
            >
              <Tab label="Academic" />
              <Tab label="Music" />
            </Tabs>
            
            {tabIndex === 0 &&
              <>
                <Box sx={{ pt: 1 }}>
                  <ResourcesForm getAllResources={getAllResources} tab = 'academic' />
                </Box>
                <Box sx={{ pt: 1 }}>
                  <ResourcesList
                    allResources={allResources}
                    getAllResources={getAllResources} />
                </Box>
              </>}

            {tabIndex === 1 &&
              <>
                <Box sx={{ pt: 1 }}>
                  <ResourcesForm getAllResources={getMusicResources} tab = 'music' />
                </Box><Box sx={{ pt: 1 }}>
                  <ResourcesList
                    allResources={musicResources}
                    getAllResources={getMusicResources} />
                </Box>
              </>}
            {/* Content for the selected tab */}

          </Container>
        </Box>
      </div>
    </>
  );
};

export default Resources;
